module.exports = __webpack_public_path__ + "img/2-6.61028901.jpg";